/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGlobalRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteGlobalRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteGlobalRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGlobalRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteGlobalRemoteSessionIssuerSecurity$Outbound,
    DeleteGlobalRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteGlobalRemoteSessionIssuerSecurityToJSON(
  deleteGlobalRemoteSessionIssuerSecurity:
    DeleteGlobalRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DeleteGlobalRemoteSessionIssuerSecurity$outboundSchema.parse(
      deleteGlobalRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DeleteGlobalRemoteSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGlobalRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    DeleteGlobalRemoteSessionIssuerRequest$Outbound,
    DeleteGlobalRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteGlobalRemoteSessionIssuerRequestToJSON(
  deleteGlobalRemoteSessionIssuerRequest:
    DeleteGlobalRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    DeleteGlobalRemoteSessionIssuerRequest$outboundSchema.parse(
      deleteGlobalRemoteSessionIssuerRequest,
    ),
  );
}
